module.exports = __webpack_public_path__ + "img/01.128852d8.png";